module.exports = __webpack_public_path__ + "static/media/about_pc_3.9bb46bb3.png";